import { Navbar, Nav, Container } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import endpoints from '../constants/endpoints';
import ThemeToggler from './ThemeToggler';

const styles = {
  logoStyle: {
    width: 50,
    height: 40,
  },
};

const NavBar = () => {
  const [data, setData] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    fetch(endpoints.navbar, {
      method: 'GET',
    })
      .then((res) => res.json())
      .then((res) => setData(res))
      .catch((err) => err);
  }, []);

  useEffect(() => {
    let observer;

    const observeSections = () => {
      observer?.disconnect();
      const sections = [...document.querySelectorAll('[data-nav-section]')];
      if (!sections.length || !('IntersectionObserver' in window)) return;

      observer = new IntersectionObserver(
        (entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
          if (visible) setActiveSection(visible.target.dataset.navSection);
        },
        { rootMargin: '-35% 0px -50%', threshold: [0, 0.2, 0.6] },
      );
      sections.forEach((section) => observer.observe(section));
    };

    observeSections();
    document.addEventListener('portfolio-ready', observeSections);
    return () => {
      observer?.disconnect();
      document.removeEventListener('portfolio-ready', observeSections);
    };
  }, []);

  const getHref = (section) => {
    if (section.type === 'link') return section.href;
    return section.href === '/' ? '#home' : `#${section.href.slice(1)}`;
  };

  return (
    <Navbar
      fixed="top"
      expand="md"
      className="navbar-custom"
      expanded={expanded}
      onToggle={(nextExpanded) => setExpanded(Boolean(nextExpanded))}
    >
      <Container>
        {data?.logo && (
          <Navbar.Brand href="#home" onClick={() => setExpanded(false)}>
            <span className="navbar__logo-shell">
              <img
                src={data?.logo?.source}
                className="navbar__logo-image d-inline-block align-top"
                alt="main logo"
                style={
                  data?.logo?.height && data?.logo?.width
                    ? { height: data?.logo?.height, width: data?.logo?.width }
                    : styles.logoStyle
                }
              />
            </span>
          </Navbar.Brand>
        )}
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
        />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto" />
          <Nav className="navbar__links">
            {data
              && data.sections?.map((section) => (section?.type === 'link' ? (
                <a
                  key={section.title}
                  href={getHref(section)}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => setExpanded(false)}
                  className="navbar__link"
                >
                  {section.title}
                </a>
              ) : (
                <a
                  key={section.title}
                  onClick={() => setExpanded(false)}
                  className={['navbar__link',
                    activeSection === (section.href === '/' ? 'home' : section.href.slice(1))
                      ? 'navbar__link--active' : '']
                    .filter(Boolean)
                    .join(' ')}
                  href={getHref(section)}
                >
                  {section.title}
                </a>
              )))}
          </Nav>
          <div className="navbar__actions">
            <ThemeToggler onClick={() => setExpanded(false)} />
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavBar;
